import React from "react";
import { Container, Row, Col } from "reactstrap";
import { SectionHeading } from "../SectionHeading/SectionHeading";
import FontAwesomeIcon from "react-fontawesome";
import "./contacts.css";

const Contacts = () => (
  <Container id="contacts" className="py-5 my-4" name="contacts">
    <SectionHeading title="Join us on this trip!" />
    <p className="text-center mb-5"> Give us a call or send us an email. </p>
    <Row>
      <Col xs="12" lg="6" className="text-center">
        <FontAwesomeIcon
          className="py-3"
          name="phone"
          size="2x"
          style={{ textShadow: "0 1px 0 rgba(0, 0, 0, 0.1)" }}
        />
        <p>(+351) 937 434 488 </p>
        <p>(+351) 913 881 001</p>
      </Col>
      <Col xs="12" lg="6" className="text-center">
        <FontAwesomeIcon
          className="py-3"
          name="envelope"
          size="2x"
          style={{ textShadow: "0 1px 0 rgba(0, 0, 0, 0.1)" }}
        />
        <p className="mail-address">
          <a href="mailto:geral@moonwayfilms.com">geral@moonwayfilms.com</a>
        </p>
      </Col>
    </Row>
  </Container>
);

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Contacts/Contacts.js